// Services
import { AjaxService } from 'NewAngular/services/core/ajax.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/ajax.service";
import * as i2 from "NewAngular/services/core/urls.service";
export class CustomPDFReportService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
    }
    getPDFReports(securityId, dataSource) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.COLLECTION;
        return this.ajaxService.getDataObserveBody(url, { securityId, dataSource });
    }
    getTearsheetPDFReports(reportType, reportOrientation) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.TEARSHEET_COLLECTION;
        return this.ajaxService.getDataObserveBody(url, { reportType, reportOrientation });
    }
    getPDFReportModuleCategoryMenu(reportType, reportOrientation, dataSource) {
        let url = '';
        if (reportOrientation === null) {
            url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.MODULE_MENU, { reportType });
        }
        else {
            url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.MODULE_MENU, { reportType }, { orientation: reportOrientation, dataSource });
        }
        return this.ajaxService.getDataObserveBody(url);
    }
    getPDFReport(reportId) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.getDataObserveBody(url);
    }
    postPDFReport(postParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.COLLECTION;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    putPDFReport(reportId, putParams) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.putJsonDataObserveBody(url, putParams);
    }
    generatePDFReport(reportId, postParams) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    generateUnsavedPDFReport(generationParams, reportParams, modules, filterLegacy = false) {
        const queryParams = filterLegacy ? { filterLegacy } : {};
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.UNSAVED_REPORT_GENERATION, {}, queryParams);
        return this.ajaxService.postJsonDataObserveBody(url, {
            generationParams,
            reportParams,
            modules,
        });
    }
    deletePDFReport(reportId) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT, { reportId });
        return this.ajaxService.deleteDataObserveResponse(url);
    }
    duplicatePDFReport(reportId, newName) {
        const urlParams = { reportId };
        const postParams = { name: newName };
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.DUPLICATE, urlParams);
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    getPDFReportsList(getParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.LIST;
        return this.ajaxService.getDataObserveBody(url, getParams);
    }
    validatePDFReportModule(reportType, module) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_MODULE, { reportType });
        return this.ajaxService.postJsonDataObserveBody(url, module);
    }
    getPDFReportTemplate(templateId, reportOrientation) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.PDF_REPORT_TEMPLATE, {
            templateId,
            reportOrientation,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    validateReportSecurityList(reportId, securityListName, securityGroup) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_SECURITY_LIST, {
            reportId,
            securityListName,
            securityGroup,
        });
        return this.ajaxService.getDataObserveBody(url);
    }
    validateReportSecurities(reportId, modules, security_ids, securitylist_group) {
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_SECURITIES, {
            reportId,
        });
        return this.ajaxService.postJsonDataObserveBody(url, { security_ids, securitylist_group, modules });
    }
    reorientPDFReport(postParams) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.REORIENT_PDF;
        return this.ajaxService.postJsonDataObserveBody(url, postParams);
    }
    getWizardStepsFromModules(modules, reportType) {
        const url = this.urlsService.CUSTOM_PDF_REPORTS.WIZARD_STEPS;
        return this.ajaxService.postJsonDataObserveBody(url, { reportType, modules });
    }
    validateDataSource(reportParams, modules) {
        // We do not care about the success responses, only the error responses
        const url = this.urlsService.getUrl(this.urlsService.CUSTOM_PDF_REPORTS.VALIDATE_DATA_SOURCE);
        return this.ajaxService.postJsonDataObserveBody(url, {
            reportParams,
            modules,
        });
    }
}
CustomPDFReportService.ɵfac = function CustomPDFReportService_Factory(t) { return new (t || CustomPDFReportService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
CustomPDFReportService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: CustomPDFReportService, factory: CustomPDFReportService.ɵfac, providedIn: 'root' });
